module.exports = __webpack_public_path__ + "img/equipos-moviles-gal-2-zoom.b27bbb9f.jpg";